import logoUrl from "../../../../assets/logo.png";

export function Logo(): React.JSX.Element {
  return (
    <div className="brand">
      <span className="logo-mark" aria-hidden="true">
        <img src={logoUrl} alt="" />
      </span>
      <span>MemoKite</span>
    </div>
  );
}
